import {ActiveInfoPageConfig} from '@/components/Ui/ActiveInfoPage/BZCore/ActiveInfoPage'

import studentAvatar from '@/components/Students/Page/studentAvatar.vue'
import studentContacts from '@/components/Students/Page/studentContacts.vue'
import studentEduInfo from '@/components/Students/Page/studentEduInfo.vue'
import studentDebtInfo from '@/components/Students/Page/studentDebtInfo.vue'
import studentDocuments from '@/components/Students/Page/studentDocuments.vue'
import studentSystemInfo from '@/components/Students/Page/studentSystemInfo.vue'
import studentInfo from '@/components/Students/Page/studentInfo.vue'
import studentMsgrs from '@/components/Students/Page/msgrs.vue'
import studentManagement from '@/components/Students/Page/management.vue'
import studentPassword from '@/components/Students/Page/password.vue'
import studentMsgrsHist from '@/components/Students/Page/msgrsHist.vue'

import studentGeneralInfo from '@/components/Students/Page/generalInfo.vue'
import studentComments from '@/components/Students/Page/comments.vue'

const studentActiveInfoPage: ActiveInfoPageConfig = {
  mapsColumns: {
    lg: [['avatar', 'generalInfo', 'msgrs', 'comments', 'contacts', 'eduInfo', 'documents', 'password', 'management', 'systemInfo', 'debtInfo'], ['info', 'msrgHist']],
    xs: [['info', 'msrgHist', 'generalInfo', 'msgrs', 'comments', 'contacts', 'eduInfo', 'documents', 'password', 'management', 'systemInfo', 'debtInfo']]
  },
  blocks: {
    avatar: {
      block: studentAvatar,
      options: {}
    },
    generalInfo: {
      block: studentGeneralInfo,
      options: {}
    },
    msgrs: {
      block: studentMsgrs,
      options: {}
    },
    comments: {
      block: studentComments,
      options: {}
    },
    contacts: {
      block: studentContacts,
      options: {}
    },
    eduInfo: {
      block: studentEduInfo,
      options: {}
    },
    debtInfo: {
      block: studentDebtInfo,
      options: {}
    },
    documents: {
      block: studentDocuments,
      options: {}
    },
    systemInfo: {
      block: studentSystemInfo,
      options: {}
    },
    info: {
      block: studentInfo,
      options: {}
    },
    password: {
      block: studentPassword,
      options: {}
    },
    management: {
      block: studentManagement,
      options: {}
    },
    msrgHist: {
      block: studentMsgrsHist,
      options: {}
    }
  }
}
export default studentActiveInfoPage